module.exports = __webpack_public_path__ + "static/media/8OLA20.b60d4c3f.jpg";